import React from 'react';
import ReactDOM from 'react-dom';
import 'rc-tree/assets/index.css';
import '@pathofdev/react-tag-input/build/index.css';
import 'react-loading-skeleton/dist/skeleton.css';
import './assets/css/custom.css';
import './assets/css/tailwind.css';
import './assets/css/tailwind.output.css';
import App from './App';
import myTheme from './assets/theme/myTheme';
import { Windmill } from '@windmill/react-ui';
import { AdminProvider } from './context/AdminContext';
import { SidebarProvider } from './context/SidebarContext';
import { ChatStatusProvider } from './context/ChatStatusContext';
import InactivityHandler from 'InactivityHandler';
import { Provider } from 'react-redux';
import store from './redux/Store';
import './i18n';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

// import * as serviceWorker from './serviceWorker';

// if (process.env.NODE_ENV !== "production") {
//   const axe = require("react-axe");
//   axe(React, ReactDOM, 1000);
// }

ReactDOM.render(
	<AdminProvider>
		<SidebarProvider>
			<Provider store={store}>
				<Windmill usePreferences theme={myTheme}>
					<ChatStatusProvider>{' '}
						<InactivityHandler>
							<App />{' '}
						</InactivityHandler>
					</ChatStatusProvider>
				</Windmill>
			</Provider>
		</SidebarProvider>
	</AdminProvider>,

	document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
